import { useMatches } from "@tanstack/react-router";
import { useEffect } from "react";

const DEFAULT_TITLE = "WebTemplate";

/**
 * Updates `document.title` based on the deepest matched route's `staticData.title`.
 * Format: "Page Title | WebTemplate" (or just "WebTemplate" if no title is set).
 *
 * This ensures screen readers announce page changes and browser tabs show the current page.
 */
export function useDocumentTitle(): void {
  const matches = useMatches();

  useEffect(() => {
    // Walk matches in reverse to find the deepest route with a title
    let pageTitle: string | undefined;
    for (let i = matches.length - 1; i >= 0; i--) {
      const title = matches[i].staticData?.title;
      if (title) {
        pageTitle = title;
        break;
      }
    }

    document.title = pageTitle ? `${pageTitle} | ${DEFAULT_TITLE}` : DEFAULT_TITLE;
  }, [matches]);
}
